module.exports = __webpack_public_path__ + "img/footer-map.5abe4f14.png";